import PropTypes from 'prop-types';
import React from 'react';
import ReportDefinitions from '../../../../common/config/ReportDefinitions';
import Report from '../../../common/components/Report';
import noop from "../../../../../core/modules/common/tools/noop";

const CarrierNestingReport = props => (
  <Report
    id={props.id}
    tabs={[
      {
        value: ReportDefinitions.CARDIT_NESTING_OPERATOR_801.id,
        label: 'Operator',
      },
      {
        value: ReportDefinitions.CARDIT_NESTING_LOCATION_801.id,
        label: 'Location',
        loadFromTable: true,
        loadFromTableMessage: 'app.warning.load.from.summary.report',
      },
      {
        value: ReportDefinitions.CARDIT_NESTING_DETAILS_801.id,
        label: 'Details',
        loadFromTable: true,
        loadFromTableMessage: 'app.warning.load.from.summary.report',
      },
    ]}
    {...props}
  />
);
export default CarrierNestingReport;

CarrierNestingReport.propTypes = {
  id: PropTypes.string,
  data: PropTypes.arrayOf(PropTypes.object),
  columns: PropTypes.arrayOf(PropTypes.object),
  generatedOnDateTime: PropTypes.string,
  isLoading: PropTypes.bool,
  reportId: PropTypes.string,
  onSortedChange: noop,
  onFilteredChange: noop,
};
